/*============================================================================
  Minimal AOS (Animate On Scroll) Implementation
  Specifically for background-image-text section animations
==============================================================================*/

(function() {
  'use strict';

  // Simple AOS implementation
  const AOS = {
    elements: [],
    initialized: false,

    init: function(options = {}) {
      if (this.initialized) return;
      
      this.options = {
        offset: options.offset || 60,
        easing: options.easing || 'ease-out-quad',
        duration: options.duration || 400,
        once: options.once || true,
        disableMutationObserver: options.disableMutationObserver || true,
        ...options
      };

      // Set global attributes
      document.body.setAttribute('data-aos-easing', this.options.easing);
      document.body.setAttribute('data-aos-duration', this.options.duration);

      this.refresh();
      this.initialized = true;

      // Listen to scroll events
      window.addEventListener('scroll', this.handleScroll.bind(this));
      window.addEventListener('resize', this.refresh.bind(this));
      window.addEventListener('orientationchange', this.refresh.bind(this));

      return this.elements;
    },

    refresh: function() {
      this.elements = this.getElements();
      this.handleScroll();
    },

    refreshHard: function() {
      this.elements = [];
      this.refresh();
    },

    getElements: function() {
      const elements = document.querySelectorAll('[data-aos]');
      return Array.from(elements).map(element => {
        return {
          node: element,
          position: this.getElementPosition(element)
        };
      });
    },

    getElementPosition: function(element) {
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return rect.top + scrollTop;
    },

    handleScroll: function() {
      const windowHeight = window.innerHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.elements.forEach(element => {
        const elementTop = element.position;
        const elementBottom = elementTop + element.node.offsetHeight;
        const triggerPoint = scrollTop + windowHeight - this.options.offset;

        if (triggerPoint >= elementTop && scrollTop <= elementBottom) {
          if (!element.node.classList.contains('aos-animate')) {
            element.node.classList.add('aos-animate');
            
            // Special handling for background-media-text sections
            if (element.node.getAttribute('data-aos') === 'background-media-text__animation') {
              element.node.classList.add('loaded');
            }
          }
        } else if (!this.options.once) {
          element.node.classList.remove('aos-animate');
          
          if (element.node.getAttribute('data-aos') === 'background-media-text__animation') {
            element.node.classList.remove('loaded');
          }
        }
      });
    }
  };

  // Make AOS available globally
  window.AOS = AOS;

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      AOS.init({
        easing: 'ease-out-quad',
        once: true,
        offset: 60,
        disableMutationObserver: true
      });
    });
  } else {
    // DOM is already loaded
    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });
  }

})();